import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
import { SectionH } from '../../oasis-sections/section-h';
import { OASIS } from '../../oasis-types';
import { isActive, isTimepoint, TEMP_VERSION } from '../util';
/**
 *
 * Note: if there's an overlapping error for a particular field this is the order in which they'll be displayed
 * form level
 * section level
 * field level
 * base level: same level as "field", but uses built int zod validations
 */
// eslint-disable-next-line
export const sectionHConsistency = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    const payload = input;
    // H-consistency-4320 If M0100_ASSMT_REASON=[09], then if M1600_UTI is active it cannot equal [UK].
    if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
        isActive(SectionH.m1600, TEMP_VERSION, payload.SectionA?.m0100) &&
        payload.SectionH?.m1600 === 'UK') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-4320 M1600 cannot equal 'UK'.",
            path: ['SectionH', 'm1600'],
        });
    }
    // H-consistency-4351 If M0100_ASSMT_REASON=[09], then if M1620_BWL_INCONT is active it cannot equal [UK].
    if (isTimepoint([OASIS.DSCH], payload.SectionA?.m0100) &&
        isActive(SectionH.m1620, TEMP_VERSION, payload.SectionA?.m0100) &&
        payload.SectionH?.m1620 === 'UK') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-4351 M1620 cannot equal 'UK'.",
            path: ['SectionH', 'm1620'],
        });
    }
    // H-consistency-4361 If M0100_ASSMT_REASON = [01,03], and M1620_BWL_INCONT = [00,01,02,03,04,05,UK], then if M1630_OSTOMY is active it must equal [00].
    if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
        ['00', '01', '02', '03', '04', '05', 'UK'].includes(payload.SectionH?.m1620 || '') &&
        isActive(SectionH.m1630, TEMP_VERSION, payload.SectionA?.m0100) &&
        payload.SectionH?.m1630 !== '00') {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-4361 If M1620 = 0, 1, 2, 3, 4, 5, or UK, then M1630 must equal 0.',
            path: ['SectionH', 'm1630'],
        });
    }
    // H-consistency-4371 If M0100_ASSMT_REASON = [01,03], and M1620_BWL_INCONT = [NA], then if M1630_OSTOMY is active it must equal [01,02].
    if (isTimepoint([OASIS.SOC, OASIS.ROC], payload.SectionA?.m0100) &&
        payload.SectionH?.m1620 === 'NA' &&
        isActive(SectionH.m1630, TEMP_VERSION, payload.SectionA?.m0100) &&
        !['01', '02'].includes(payload.SectionH?.m1630 || '')) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-4371 If M1620 = NA, then M1630 must equal 1 or 2.',
            path: ['SectionH', 'm1630'],
        });
    }
};
// H-consistency-4320 If M0100_ASSMT_REASON=[09], then if M1600_UTI is active it cannot equal [UK].
// H-consistency-4351 If M0100_ASSMT_REASON=[09], then if M1620_BWL_INCONT is active it cannot equal [UK].
// H-consistency-4361 If M0100_ASSMT_REASON = [01,03,09], and M1620_BWL_INCONT = [00,01,02,03,04,05,UK], then if M1630_OSTOMY is active it must equal [00].
// H-consistency-4371 If M0100_ASSMT_REASON = [01,03,09], and M1620_BWL_INCONT = [NA], then if M1630_OSTOMY is active it must equal [01,02].
